import { RootState } from 'store';

import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { STATIONS_STATE } from '../../constants';

export const useBestRouteStations = () => {
  const bestRouteStations = useSelector((state: RootState) => state[STATIONS_STATE].bestRouteStations.data);
  return bestRouteStations;
};

export const useBestRouteStationCodesMap = () => {
  const bestRouteStations = useBestRouteStations();

  const bestRouteStationCodesMap = useMemo(() => (bestRouteStations || [])
    .reduce((acc, { stationCode }) => {
      acc[stationCode] = true;
      return acc;
    }, {} as { [stationCode: string]: boolean; }
  ), [bestRouteStations]);

  return bestRouteStationCodesMap;
}